


















































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import MachineImg from '@/app/components/Machine/MachineImg.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import search from '@/app/components/MachineRentStatus/MachineRentStatusSearch.vue'
/* api */
import MachineRentListApi from '@/app/model/api/machineRentListApi'
import MachineDetailApi from '@/app/model/api/machineDetailApi'
import GetMachineImgApi from '@/app/model/api/getMachineImgApi'
import MachineListApi from '@/app/model/api/machineListApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import DateClass from '@/app/module/date'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    search,
    MachineImg
  }
})
export default class machineRent extends Vue {
  private showLoading: boolean = true
  private notDataMessage: boolean = false
  private totalCount: number = 0
  private machineRentDefultData: any = {}
  private groupByMachineRentData: any = {}
  private machineData: any = {}
  private displayMachineType: number|null = null
  private constantValue: any
  private scTimer: number = 0
  private scY: number = 0

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.getMachineList()
  }

  mounted () {
    const el: any = document.getElementById('listContainer')
    if (el !== null) {
      el.addEventListener('scroll', this.handleScroll)
    }
  }

  private handleScroll () {
    const el: any = document.getElementById('listContainer')
    if (this.scTimer) {
      return
    }
    this.scTimer = setTimeout(() => {
      this.scY = el.scrollTop
      clearTimeout(this.scTimer)
      this.scTimer = 0
    }, 100)
  }

  /* 機械タイプの判定 */
  private judgmentMachineType (type: number) {
    for (let i in this.constantValue.machine_types) {
      if (this.constantValue.machine_types[i].machine_type_id === type) {
        return this.constantValue.machine_types[i].machine_type_name
      }
    }
  }

  private dateToStringYmd (date: any, unit: string) {
    if (date !== null && date !== '') {
      return DateClass.dateToStringYmd(new Date(date), unit)
    } else {
      return ''
    }
  }

  /* 貸出ステータスの判定 */
  private judgmentStatusName (step: number) {
    for (let i in this.constantValue.machine_steps) {
      if (this.constantValue.machine_steps[i].step === step) {
        return this.constantValue.machine_steps[i].status_name
      }
    }
  }

  /*  行動ステップの判定 */
  private judgmentStepName (step: number) {
    if (step === null) {
      return '-'
    }

    for (let i in this.constantValue.machine_steps) {
      if (this.constantValue.machine_steps[i].step === step) {
        return this.constantValue.machine_steps[i].step_name
      }
    }
  }

  private machineRentStatusData: any = []

  private getMachineList () {
    (async () => {
      const data = {
        word: '',
        order_name: 'machine_name',
        sort: true,
        is_valid: null,
        machine_type: null
      }

      const result = await MachineListApi.getMachineList(data)

      if (result.isOk()) {
        this.machineData = result.getPayload().results
        for (let i in this.machineData) {
          this.machineRentStatusData.push({
            machine: {
              machine_name: this.machineData[i].machine_name,
              machine_id: this.machineData[i].machine_id,
              machine_type: this.machineData[i].machine_type,
              is_valid: this.machineData[i].is_valid,
              model: this.machineData[i].model,
              serial_number: this.machineData[i].serial_number,
              image_path: this.machineData[i].image_path
            },
            now_status: null,
            next_status: null,
            rent_days: [{
              highlight: {
                color: 'orange',
                fillMode: 'light'
              },
              contentStyle: {
                color: 'white'
              },
              dates: []
            },
            {
              dot: 'red',
              dates: [
                new Date()
              ]
            }]
          })
        }
        await this.getMachineRentList()
        this.groupByMachineRentData = await this.groupByMachineType(this.machineRentStatusData)
        this.machineRentDefultData = this.groupByMachineRentData

        this.totalCount = result.getPayload().total_count
        if (this.totalCount === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private getMachineRentList () {
    (async () => {
      const data = {
        word: '',
        order_name: 'created_at',
        sort: false,
        rent_status: 1,
        machine_type: null,
        page: 1
      }

      const result = await MachineRentListApi.getMachineRentList(data)

      if (result.isOk()) {
        const machineGroupData = this.groupByMachineId(result.getPayload().results)
        for (let k in this.machineRentStatusData) {
          for (let i in machineGroupData) {
            if (this.machineRentStatusData[k].machine.machine_id === machineGroupData[i].machine_id) {
              if (machineGroupData[i].machines.length === 1) {
                this.machineRentStatusData[k].now_status = {
                  field_name: machineGroupData[i].machines[0].field_name,
                  field_id: machineGroupData[i].machines[0].field_id,
                  machine_rent_id: machineGroupData[i].machines[0].machine_rent_id,
                  rent_start_date: machineGroupData[i].machines[0].rent_start_date,
                  rent_end_date: machineGroupData[i].machines[0].rent_end_date,
                  step: machineGroupData[i].machines[0].step,
                  next_step: machineGroupData[i].machines[0].next_step,
                  plan_date: machineGroupData[i].machines[0].plan_date,
                  rent_days: machineGroupData[i].machines[0].rent_days,
                  rent_time: machineGroupData[i].machines[0].rent_time
                }
              } else {
                machineGroupData[i].machines.sort(
                  function (a: any, b: any) {
                    return (a.rent_start_date < b.rent_start_date ? -1 : 1)
                  }
                )
                this.machineRentStatusData[k].now_status = {
                  field_name: machineGroupData[i].machines[0].field_name,
                  field_id: machineGroupData[i].machines[0].field_id,
                  machine_rent_id: machineGroupData[i].machines[0].machine_rent_id,
                  rent_start_date: machineGroupData[i].machines[0].rent_start_date,
                  rent_end_date: machineGroupData[i].machines[0].rent_end_date,
                  step: machineGroupData[i].machines[0].step,
                  next_step: machineGroupData[i].machines[0].next_step,
                  plan_date: machineGroupData[i].machines[0].plan_date,
                  rent_days: machineGroupData[i].machines[0].rent_days,
                  rent_time: machineGroupData[i].machines[0].rent_time
                }
                this.machineRentStatusData[k].next_status = {
                  field_name: machineGroupData[i].machines[1].field_name,
                  field_id: machineGroupData[i].machines[1].field_id,
                  machine_rent_id: machineGroupData[i].machines[1].machine_rent_id,
                  rent_start_date: machineGroupData[i].machines[1].rent_start_date,
                  rent_end_date: machineGroupData[i].machines[1].rent_end_date,
                  step: machineGroupData[i].machines[1].step,
                  next_step: machineGroupData[i].machines[1].next_step,
                  plan_date: machineGroupData[i].machines[1].plan_date,
                  rent_days: machineGroupData[i].machines[1].rent_days,
                  rent_time: machineGroupData[i].machines[1].rent_time
                }
              }
              let days: any = []
              for (let j in machineGroupData[i].machines) {
                days.push({
                  start: new Date(machineGroupData[i].machines[j].rent_start_date),
                  end: new Date(machineGroupData[i].machines[j].rent_end_date)
                })
              }
              this.machineRentStatusData[k].rent_days[0].dates = days
            }
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  // 今日からあと何日か計算
  private calculationDiffDays (date: string) {
    const today: any = new Date()
    const rentStartDate: any = new Date(date)
    const termDay: any = Math.floor((rentStartDate - today) / 86400000)

    if (termDay < 0) {
      return 0
    } else {
      return termDay
    }
  }

  // 今からあと何時間か計算
  private calculationDiffTime (date: string) {
    const today = new Date().getTime()
    const rentStartDate = new Date(date).getTime()
    const time = Math.floor((rentStartDate - today) / (60 * 60 * 1000) % 24)

    if (time < 0) {
      return 0
    } else {
      return time
    }
  }

  private changeList (machineType: number) {
    this.showLoading = true
    this.displayMachineType = machineType
    if (machineType === null) {
      this.groupByMachineRentData = this.machineRentDefultData
      this.totalCount = this.machineData.length
    } else {
      for (let i in this.machineRentDefultData) {
        if (this.machineRentDefultData[i].machine_type === machineType) {
          let list = []
          list.push(this.machineRentDefultData[i])
          this.groupByMachineRentData = list

          this.totalCount = this.machineRentDefultData[i].machines.length
        }
      }
    }
    // 0件の場合の表示切替
    if (this.totalCount === 0) {
      this.notDataMessage = true
    } else {
      this.notDataMessage = false
    }

    this.scrollTop()
    this.showLoading = false
  }

  private scrollTop () : any {
    const listArea: any = document.getElementById('listContainer')!
    listArea.scrollTop = 0
  }

  private groupByMachineType (array: any) {
    const machineTypeArray = array.reduce(function (rv: any, x: any) {
      (rv[x.machine.machine_type] = rv[x.machine.machine_type] || []).push(x)
      return rv
    }, {})
    let list = []
    for (var k in machineTypeArray) {
      list.push({
        machine_type: machineTypeArray[k][0].machine.machine_type,
        machines: machineTypeArray[k]
      })
    }
    return list
  }

  private groupByMachineId (array: any) {
    const machineTypeArray = array.reduce(function (rv: any, x: any) {
      (rv[x.machine_id] = rv[x.machine_id] || []).push(x)
      return rv
    }, {})
    let list = []
    for (var k in machineTypeArray) {
      list.push({
        machine_id: machineTypeArray[k][0].machine_id,
        machines: machineTypeArray[k]
      })
    }
    return list
  }
}
